
import { Box, Stack, Text } from "@chakra-ui/react";
import { getSortedSessionPlayerIDs, LeaderboardType, SessionState, SocketID } from "jparty-shared";
import { useContext, useRef } from "react";
import { PiCrownSimpleFill } from "react-icons/pi";

import { LayoutContext } from "../common/Layout";
import { formatDollarValueString, getScoreFontSize } from "../../misc/client-utils";

const LEADERBOARD_SPOT_LABELS: Record<LeaderboardType, string> = {
    [LeaderboardType.AllTime]: "on the all time leaderboard",
    [LeaderboardType.Monthly]: "on the monthly leaderboard",
    [LeaderboardType.Weekly]: "on the weekly leaderboard"
};

export default function HostScoreboard() {
    const context = useContext(LayoutContext);

    const frozenSessionPlayersRef = useRef(context.sessionPlayers);
    if (context.sessionState === SessionState.GameOver) {
        frozenSessionPlayersRef.current = context.sessionPlayers;
    }

    const sessionPlayers = frozenSessionPlayersRef.current;

    return (
        <Stack direction={"column"} gap={"1em"} width={"fit-content"} marginLeft={"auto"} marginRight={"auto"}>
            {getSortedSessionPlayerIDs(sessionPlayers).map((playerID: SocketID, index: number) => {
                const player = sessionPlayers[playerID];
                const isEvenPlayerIndex = index % 2 == 0;

                if (index > 2) {
                    return;
                }

                return (
                    <Stack key={player.clientID} className={`scoreboard-player-box ${isEvenPlayerIndex ? "even" : "odd"}`} direction={"row"}>
                        {/* signature */}
                        <Box className={"child-box"} marginRight={"0.5em"} height={"7em"} width={"7em"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <img src={player.signatureImageBase64} />
                        </Box>

                        {/* name and score */}
                        <Box className={"child-box"} minWidth={"15vw"} height={"7em"} paddingLeft={"0.5em"} flexGrow={1}>
                            <Stack direction={"column"} paddingRight={"1em"} overflow={"hidden"}>
                                <Box textAlign={"left"} whiteSpace={"nowrap"}>
                                    <Stack direction={"row"} gap={"0.2em"} fontSize={"1.5em"}>
                                        <Box position={"relative"} top={"0.35em"}>
                                            {(index === 0 && player.score > 0) && <PiCrownSimpleFill style={{ display: "block" }} />}
                                        </Box>
                                        <b>{player.name}</b>
                                        {player.claimedLeaderboardSpot && (
                                            <Text fontSize={"0.8em"} alignSelf={"center"}>
                                                <i>(#{player.claimedLeaderboardSpot.spot} {LEADERBOARD_SPOT_LABELS[player.claimedLeaderboardSpot.type]})</i>
                                            </Text>
                                        )}
                                    </Stack>
                                </Box>

                                <Box textAlign={"left"} whiteSpace={"nowrap"}>
                                    <Text fontSize={getScoreFontSize(player.score, 4)} position={"relative"} bottom={"0.3em"}>
                                        <i>{formatDollarValueString(player.score)}</i>
                                    </Text>
                                </Box>
                            </Stack>
                        </Box>
                    </Stack>
                );
            })}
        </Stack>
    );
}